import { jsx as _jsx } from "react/jsx-runtime";
import { TS_EditableContent } from '../TS_EditableContent/TS_EditableContent.js';
import { EditableItemStatus_Creating, EditableItemStatus_ErrorSaving, EditableItemStatus_FailedValidation, EditableItemStatus_Saved, EditableItemStatus_SavedWithErrors, EditableItemStatus_Saving, EditableItemStatus_Unknown, EditableItemStatus_UnsavedChanges } from '../../utils/EditableItem.js';
export class TS_EditableItemStatus extends TS_EditableContent {
    static defaultProps = {
        labels: {
            [EditableItemStatus_Saving]: 'Saving...',
            [EditableItemStatus_SavedWithErrors]: 'Saved With Errors',
            [EditableItemStatus_FailedValidation]: 'Validation Error',
            [EditableItemStatus_ErrorSaving]: 'Saving Failed',
            [EditableItemStatus_UnsavedChanges]: 'Unsaved Changes',
            [EditableItemStatus_Creating]: 'Creating New',
            [EditableItemStatus_Saved]: 'Saved',
            [EditableItemStatus_Unknown]: 'Not Implemented',
        }
    };
    deriveStateFromProps(nextProps, _state) {
        const state = super.deriveStateFromProps(nextProps, _state);
        state.statusLabel = this.props.labels[_state.editable.getStatus()] ?? 'Missing Status';
        return state;
    }
    componentDidMount() {
        setTimeout(() => this.props.editable.addStatusListener(this), 0);
    }
    componentWillUnmount() {
        this.props.editable.removeStatusListener(this);
    }
    onEditableItemStatusChanged(newStatus) {
        this.reDeriveState({});
    }
    render() {
        return _jsx("div", { className: 'ts-editable-item-status', children: this.state.statusLabel });
    }
}
//# sourceMappingURL=TS_EditableItemStatus.js.map